export default "https://cdn-static.gokick.com/assets/fe83fbcc8f1f3696644045565519fd390c3f6ffc/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";